module.exports = __webpack_public_path__ + "static/media/join-business.bed5eff5.svg";